export default __webpack_public_path__ + "static/media/Hero_Academia_MateCuMatei.6fc952ed.jpg";